import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    infoCardCell: {
        [theme.breakpoints.up('xs')]: {
            paddingRight: '0px',
            paddingBottom: '20px',
        },
        [theme.breakpoints.up('sm')]: {
            paddingRight: '20px',
            paddingBottom: '0px',
        },
        [theme.breakpoints.up('md')]: {
            paddingRight: '0px',
            paddingBottom: '20px',
        },
        [theme.breakpoints.up('lg')]: {
            paddingRight: '0px',
            paddingBottom: '20px',
        },
        [theme.breakpoints.up('xl')]: {
            paddingRight: '0px',
            paddingBottom: '20px',
        },
        [theme.breakpoints.up('xxl')]: {
            paddingRight: '0px',
            paddingBottom: '20px',
        },
    },
}));
